import React from 'react';
import { Button } from 'carbon-components-react';
import { Add16, Delete16 } from '@carbon/icons-react';
import './ArrayTemplate.css';

const ArrayTemplate = props => {
  return (
    <div className='form-item-array' key={props.key}>
      {props.items.length > 0 && (
        <h6 className='form-array-title'>{props.schema.title}</h6>
      )}
      {props.items.map(element => {
        if (element.children.props.schema.properties.objSubtype !== undefined) {
          return (
            <div
              key={element.key}
              className={
                element.className +
              ' form-item-object-array-row w-100 justify-content-between row m-0'
              }
            >
              {element.children}
              <div
                style={{
                  height: '100%',
                  width: '100%',
                  maxWidth: 46,
                  marginTop: 16
                }}
              >
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    className='bx--btn--ghost'
                    hasIconOnly
                    iconDescription='Borrar'
                    tooltipAlignment='center'
                    tooltipPosition='bottom'
                    onClick={element.onDropIndexClick(element.index)}
                  >
                    <Delete16 aria-label='Delete' />
                  </Button>
                </span>
              </div>
            </div>
          );
        } else {
          return (
            <div key={element.key} className='form-item-array-row'>
              {element.children}
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  className='bx--btn--ghost'
                  hasIconOnly
                  iconDescription='Borrar'
                  tooltipAlignment='center'
                  tooltipPosition='bottom'
                  onClick={element.onDropIndexClick(element.index)}
                >
                  <Delete16 aria-label='Delete' />
                </Button>
              </span>
            </div>
          );
        }
      })}

      {props.canAdd && (
        <div>
          <Button
            className='bx--btn bx--btn--ghost'
            iconDescription='Button icon'
            kind='ghost'
            onClick={props.onAddClick}
            renderIcon={Add16}
            tabIndex={10}
            size='small'
          >
            Añadir atributo
          </Button>
        </div>
      )}
    </div>
  );
};

export default ArrayTemplate;
